export default "__VITE_ASSET__edb42935__"